import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const DeploymentTargetContext = /*#__PURE__*/createContext({
  deploymentTargetName: 'development'
});
function DeploymentTargetProvider({
  deploymentTargetName,
  children
}) {
  return /*#__PURE__*/jsx(DeploymentTargetContext.Provider, {
    value: {
      deploymentTargetName
    },
    children: children
  });
}
const useDeploymentTargetContext = () => useContext(DeploymentTargetContext);
export { DeploymentTargetProvider, useDeploymentTargetContext };
//# sourceMappingURL=DeploymentTargetProvider.js.map
